<template>
  <div>
    <Help :currentStep="2" :info="info" />
    <div
      class="flex flex-col file-container animate__animated animate__flipInX"
    >
      <div class="mb-8 text-center">
        <h1 class="text-4xl font-bold">Axes de reflexion</h1>
        <p class="font-medium">
          {{ currentModule ? currentModule.name : "" }} -
          {{ currentFolder ? currentFolder.name : "" }}
        </p>
      </div>
      <div
        class="border !border-secondary file-list"
        style="background: transparent"
      >
        <h3 class="mb-8 text-xl font-bold text-gray-800">
          Liste des fichiers
          <!-- <span v-if="currentFolder !== null">du dossier <b style="font-weight: 600">{{ folderName }}</b></span> -->
        </h3>
        <span
          class="absolute -top-6 right-8 btn btn-secondary"
          @click="dialog = true"
          ><i class="la la-plus"></i> Nouvel axe</span
        >
        <div class="flex gap-x-6" :key="eltKey" v-if="datasToShow.length > 0">
          <div
            class="flex flex-col w-32 p-2 rounded-lg cursor-pointer"
            ref="file"
            v-for="(file, index) in datasToShow"
            :key="index"
            @click="goToModule(file)"
          >
            <div class="text-center has-tooltip">
              <div
                @click.stop
                class="flex flex-col items-start justify-start p-2 text-black transition-all duration-300 bg-white rounded shadow-2xl cursor-default text-stratoblue ring-1 ring-stratoblue tooltip"
              >
                <div class="font-bold">{{ file.name }}</div>

                <p class="mt-2 text-sm font-bold">Description</p>
                <div
                  class="text-sm font-light font-bold text-left text-gray-800"
                >
                  {{ file.description }}
                </div>

                <div class="flex justify-end w-full mt-2 gap-x-4">
                  <span
                    class="cursor-pointer folder-edit"
                    @click.stop="handleEdit(file)"
                  >
                    <span class="mr-1 text-sm text-stratoblue">Modifier</span>
                    <i class="fas fa-edit text-stratoblue"></i>
                  </span>
                  <span
                    class="cursor-pointer folder-delete"
                    @click.stop="handleDelete(file)"
                  >
                    <span class="mr-1 text-sm text-stratoblue">Supprimer</span>
                    <i class="text-red-600 fa fa-trash" aria-hidden="true"></i
                  ></span>
                </div>
              </div>
              <i
                class="text-center text-yellow-400 transition-all duration-100 fa fa-file-alt text-7xl hover:text-green-500"
                aria-hidden="true"
              ></i>
            </div>
            <span
              class="mb-1 text-xs text-center text-gray-800 break-words"
              @mouseenter.self="false && showTooltip(file, index)"
              @mouseleave.self="false && clearTooltip"
            >
              {{ file.name }}
            </span>
            <div class="flex justify-center hidden gap-x-4">
              <span
                class="cursor-pointer file-edit"
                @click.stop="handleEdit(file)"
                ><i class="fas fa-edit text-stratoblue"></i>
              </span>
              <span
                class="cursor-pointer file-delete"
                @click.stop="handleDelete(file)"
                ><i class="text-red-600 fa fa-trash" aria-hidden="true"></i
              ></span>
            </div>
          </div>
        </div>
        <div v-else-if="loading" class="text-xl font-bold">
          Chargement
          <i
            class="ml-4 fa fa-spinner animate-animated animate-spin text-stratoblue"
            aria-hidden="true"
          ></i>
        </div>
        <div v-else-if="error" class="flex flex-col text-xl font-bold">
          <p>Impossible de charger les fichiers, veuillez ressayer</p>
          <div class="flex justify-center">
            <button
              @click="doFilesLoading"
              class="p-2 px-4 text-sm text-white bg-stratoblue"
            >
              Réessayer
            </button>
          </div>
        </div>
        <div v-else style="color: #000">Nothing to show</div>
      </div>
    </div>

    <div class="strato-modal" v-show="dialog" @click.self="closeModal">
      <div
        class="modal-container animate__animated animate__fadeInDown"
        id="strato-modal"
      >
        <div class="modal-title">
          <h1>Ajouter un axe de reflextion</h1>
          <small
            >Description sur les opérations à effectuer dans ce modal</small
          >
          <span class="close-modal" @click.stop="closeModal"
            ><i class="la la-times"></i
          ></span>
        </div>
        <div class="modal-body">
          <div class="text-field">
            <input
              type="text"
              id="fileName"
              @keyup.enter="handleStore"
              v-model="editedElt.fileName"
              required
            />
            <label for="fileName">Nom du fichier</label>
          </div>
          <div class="text-field">
            <input
              type="text"
              id="fileDesc"
              @keyup.enter="handleStore"
              v-model="editedElt.fileDescription"
              required
            />
            <label for="fileDesc">Description du fichier</label>
          </div>

          <div class="text-field">
            <input
              type="text"
              id="fileDesc"
              @keyup.enter="handleStore"
              v-model="editedElt.fileObjectif"
              required
            />
            <label for="fileDesc">Objectif visé</label>
          </div>
        </div>

        <div class="modal-footer">
          <span class="modal-btn" @click="handleStore"
            ><i class="la la-save"></i> Enrégistrer</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
"html2canvas": "^1.3.3", "jspdf": "^2.4.0", "xlsx": "^0.17.4"
<script>
// TODO: add form inputs controls (on handlestore method)
// TODO: implement alert system
import globalMixins from "@/utils/mixins/mixin.js";
import authMixin from "@/utils/mixins/auth.mixin.js";
import Help from "@/components/Help.vue";
export default {
  mixins: [globalMixins, authMixin],

  components: { Help },

  data() {
    return {
      currentFolder: null,
      eltKey: 0,
      info: {
        name: "C'est quoi un axe de reflexion ?",
        description:
          "La problématique est la présentation d'un problème qui soulève une intérrogation qu'il faut répondre. Elle est considerée dans cette application comme un projet et représentée sous forme de dossier. Dans chaque problématique il peut y avoir plusieurs axes d'analyses qui séronts representées sous forme de fichiers."
      },
      newElt: {
        fileName: "",
        fileDescription: "",
        fileObjective: "",
        fileCode: "",
        fileObjectif: ""
      },
      editedElt: {
        fileName: "",
        fileDescription: "",
        fileObjective: "",
        fileCode: "",
        fileObjectif: ""
      },

      processTooltip: false,
      datasToShow: [],
      loading: false,
      error: false,
      editMode: false
    };
  },

  computed: {
    folderName() {
      let name = this.currentFolder.nameuserID;
      let lName = name.length;
      let finalName = lName > 20 ? name.substring(0, 20) + "..." : name;

      return finalName;
    }
  },

  created() {
    this.bValues = [
      {
        name: "Folders",
        uri: "/app/folders"
      },
      {
        name: "Files",
        uri: "/app/files"
      }
    ];

    if (this.folderKey > 0) this.resetEltClass();
  },

  mounted() {
    if (this.currentFolder === null) {
      this.$router.push("/app/folders");
      return;
    }

    this.doFilesLoading();
  },

  methods: {
    async handleDelete(item) {
      if (
        (
          await this.$swal.fire({
            title: "Êtes vous sure de vouloir supprimer " + item.name,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, Supprimer"
          })
        ).isConfirmed
      ) {
        try {
          this.$swal.fire("Suppression du fichier");
          this.$swal.showLoading();
          await this.$axios.delete(
            "/FileCommands/DeleteFile/" + item.id,
            this.editedElt
          );

          this.datasToShow = this.datasToShow.filter(x => x.id !== item.id);

          this.$toast.fire({
            title: "Le fichier a été supprimé avec success",
            icon: "success"
          });
          this.dialog = false;
        } catch (error) {
          this.$swal.fire({
            title: "Impossible de supperimer votre dossier",
            text: "Veuillez réessayer",
            icon: "error"
          });
        }
      }
    },
    //Method to start loading folders
    async doFilesLoading() {
      this.loading = true;
      this.error = false;
      try {
        const datas = await this.$axios.get(
          "/FileQueries/GetFilesByFolderID/" + this.currentFolder.id
        );
        console.log(datas);
        this.datasToShow = datas.data.map(x => ({
          ...x,
          name: x.fileName,
          description: x.fileDescription,
          objective: x.fileObjective,
          code: x.fileCode,
          id: x.fileID,
          folderID: x.folderID,
          activeStep: x.activeStep
        }));

        localStorage.setItem("temp-files", JSON.stringify(this.datasToShow));
      } catch (error) {
        console.log(error);
        this.error = true;
        this.$swal.fire({
          title: "Impossible de telecharger vos fichiers",
          text: "Veuillez réessayer",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    async handleEdit(item) {
      this.editedElt = {
        fileName: item.name,
        fileDescription: item.description,
        fileCode: item.fileCode,
        fileObjective: item.result,
        folderID: item.folderID,
        fileID: item.id,
        activeStep: item.activeStep
      };

      this.dialog = true;
      this.editMode = true;
    },

    validateForm() {
      //Validation
      if (this.editedElt.fileName.trim() === "") {
        this.$toast.fire({
          title: "Le nom du fichier est necessaire",
          icon: "error"
        });
        return false;
      }

      if (this.editedElt.fileDescription.trim() === "") {
        this.$toast.fire({
          title: "La description du fichier est necessaire",
          icon: "error"
        });
        return false;
      }
      return true;
    },
    async handleStore() {
      if (!this.validateForm()) {
        return;
      }

      if (this.editMode) {
        this.$swal.fire("Mis a jour de la problematique");
        this.$swal.showLoading();

        try {
          this.editedElt.folderID = this.currentFolder.id;
          await this.$axios.put(
            "/FileCommands/PutFile/" + this.editedElt.fileID,
            this.editedElt
          );
          const index = this.datasToShow.indexOf(
            this.datasToShow.find(x => x.id === this.editedElt.fileID)
          );
          this.datasToShow[index] = {
            ...this.datasToShow[index],
            name: this.editedElt.fileName,
            description: this.editedElt.fileDescription,
            objective: this.editedElt.fileObjective,
            code: this.editedElt.fileCode
          };
          this.editedElt = this.newElt;
          this.$toast.fire({
            title: "Le fichier a été modifié avec success",
            icon: "success"
          });
          this.dialog = false;
          this.editMode = false;
        } catch (error) {
          this.$swal.fire({
            title: "Impossible de modifier votre fichier",
            text: "Veuillez réessayer",
            icon: "error"
          });
        }

        return;
      }

      this.$swal.fire("Creation du fichier");
      this.$swal.showLoading();

      try {
        this.editedElt.folderID = this.currentFolder.id;
        const d = await this.$axios.post(
          "/FileCommands/PostFile",
          this.editedElt
        );
        this.datasToShow.push({
          name: this.editedElt.fileName,
          description: this.editedElt.fileDescription,
          objective: this.editedElt.fileObjective,
          code: d.data.fileCode,
          id: d.data.fileID,
          folderID: d.data.folderID,
          ...d.data
        });
        this.editedElt = this.newElt;
        this.$toast.fire({
          title: "Le fichier a été creé",
          icon: "success"
        });
        this.dialog = false;
      } catch (error) {
        this.$swal.fire({
          title: "Impossible de creer votre fichier",
          text: "Veuillez réessayer",
          icon: "error"
        });
      }
    },

    /**
     * Create and show tooltip element and children
     */
    showTooltip(item, id) {
      const tooltip = document.querySelectorAll(".file-name")[id];
      const name = item.name;
      const description =
        item.description.length > 0 ? item.description : "...";

      let tooltipContainer = document.createElement("div");
      let nameNode = document.createElement("span");
      let descriptionNode = document.createElement("span");

      let nameText = document.createTextNode(name);
      let descriptionText = document.createTextNode(description);

      nameNode.innerText = nameText.nodeValue;
      descriptionNode.innerText = descriptionText.nodeValue;

      nameNode.classList.add("tooltip-title");
      descriptionNode.classList.add("tooltip-desc");
      tooltipContainer.classList.add(
        "animate__animated",
        "animate__fadeInDown",
        "strato-tooltip"
      );

      tooltipContainer.appendChild(nameNode);
      tooltipContainer.appendChild(descriptionNode);

      this.processTooltip = setTimeout(() => {
        tooltip.appendChild(tooltipContainer);
      }, 350);
    },

    /**
     * Remove all generated tooltip element
     */
    clearTooltip() {
      window.clearTimeout(this.processTooltip);
      const tooltip = document.querySelectorAll(".file-name");

      tooltip.forEach(elt => {
        if (elt.children.length > 0) {
          let child = elt.children;

          child.forEach(c => {
            c.classList.remove("animate__fadeInDown", "animate__animated");
            c.classList.add("animate__animated", "animate__fadeOutUp");

            setTimeout(() => {
              c.remove();
            }, 950);
          });
        }
      });
    },

    goToModule(item) {
      localStorage.setItem("currentFile", JSON.stringify(item));
      // this.$router.push("/app/description");
      this.$router.push("/app/participants");
      //this.$router.push(this.currentModule.uri)
    },

    /**
     * Force the element with key {eltKey} to be reloaded
     */
    forceRerender() {
      this.datasToShow = this.datas.slice();
      this.eltKey += 1;
      this.$nextTick(() => {
        this.resetEltClass();
      });
    },

    /**
     * close the dialog
     */
    closeModal() {
      const elt = document.getElementById("strato-modal");

      elt.classList.remove("animate__fadeInDown");
      elt.classList.add("animate__fadeOutDown");

      setTimeout(() => {
        this.editionActive = false;
        this.dialog = false;
        this.editedIndex = -1;
        this.editedElt = Object.assign({}, this.newElt);

        elt.classList.remove("animate__fadeOutDown");
        elt.classList.add("animate__fadeInDown");
      }, 550);
    },

    /**
     * Store the current targeted element to the localStorage
     */
    saveLocal() {
      localStorage.setItem(
        "temp-file-" + this.currentFolder.name,
        JSON.stringify(this.datas)
      );
      this.closeModal();
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #161e4d;
$color2: #4e8cf5;

.file-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .file-list {
    position: relative;
    width: 80vw;
    background: $color2;
    border: solid 1px #fff;
    border-radius: 0.5rem;
    padding: 40px 20px;
    box-shadow: 0 20px 30px -16px rgba(9, 9, 16, 0.2) !important;

    .elt-title {
      position: absolute;
      top: -30px;
      left: 0;
      font-size: 1.3em;
      color: $color2;
      font-weight: 600;
      font-style: italic;
    }

    .file-add {
      position: absolute;
      top: -20px;
      right: 10px;
      border: solid 0.1px #ddd;
      font-size: 0.7em;
      color: #fff;
      cursor: pointer;
      background-color: $color2;
      border-radius: 0.5rem;
      display: inline-block;
      padding: 15px;
      box-shadow: 0 20px 30px -16px rgba(9, 9, 16, 0.2) !important;

      &:hover {
        transform: scale(0.9);
      }
    }

    .file {
      display: inline-block;
      max-width: 100px;
      margin: 10px;
      padding: 20px 15px;
      background: #fff;
      position: relative;

      .file-img {
        max-width: 70px;
        margin-bottom: 10px;
      }

      .file-name {
        display: inline-block;
        width: 100%;
        color: #777;
        font-size: 0.75em;
        font-style: italic;
        text-align: center;
        padding: 5px 0;
      }

      .file-edit,
      .file-delete {
        display: inline-block;
        position: absolute;
        bottom: -10px;
        padding: 5px;
        border-radius: 50%;
        font-size: 0.65em;
        border: solid 0.1px #fff;

        &:hover {
          transform: rotate(360deg) scale(0.8);
        }
      }

      .file-edit {
        left: 15px;
        color: #fff;
        background: $color2;
      }

      .file-delete {
        right: 15px;
        color: #fff;
        background: #700;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
